import React, { useEffect, useState } from "react";
import axios from "axios";
import { LoadingOverlay } from "./LoadingOverlay";
import { AgentCard } from "./AgentCard";
import logoImage from "../assets/logo.png";
import { Sparkle } from "lucide-react";
import agent1 from "../assets/agent1.png";
import agent2 from "../assets/agent2.png";
import agent3 from "../assets/agent3.png";
import agent4 from "../assets/agent4.png";
import agent5 from "../assets/agent5.png";
import agent6 from "../assets/agent6.png";
import { SelectedAgent } from "./SelectedAgent";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigate,
  useLocation,
} from "react-router-dom";
const SelectionPage = ({
  setUserDetails,
  userDetails,
  setMagicCode,
  magicCode,
}) => {
  const [selectedAgents, setSelectedAgents] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  // const [magicCode, setMagicCode] = useState("");

  const navigate = useNavigate();
  const location = useLocation();

  // useEffect(() => {
  //   const searchParams = new URLSearchParams(location.search);
  //   const codeFromUrl = searchParams.get("magicCode");

  //   if (codeFromUrl) {
  //     setMagicCode(codeFromUrl);
  //     localStorage.setItem("magicCode", codeFromUrl); // ✅ store in localStorage

  //     console.log("✅ Magic Code found in URL:", codeFromUrl);
  //     // 👉 you can now send this code to backend or validate it here
  //   } else {
  //     // If no magicCode query param exists, append ?magicCode=
  //     navigate(`${location.pathname}?magicCode=`, { replace: true });
  //   }
  // }, [location, navigate]);
  // function getMagicCodeFromPath() {
  //   const segments = window.location.pathname.split("/").filter(Boolean);
  //   const chatIndex = segments.indexOf("chat");

  //   if (chatIndex !== -1 && segments.length > chatIndex + 1) {
  //     return segments[chatIndex + 1]; // This is the `magicCode`
  //   }

  //   return null; // Fallback if route is unexpected
  // }
  function getMagicCodeFromPath() {
    const hashPath = window.location.hash.replace(/^#/, ""); // remove leading '#'
    const segments = hashPath.split("/").filter(Boolean);
    const chatIndex = segments.indexOf("chat");

    if (chatIndex !== -1 && segments.length > chatIndex + 1) {
      return segments[chatIndex + 1]; // this is the magicCode
    }

    return null; // fallback if no match
  }

  useEffect(() => {
    const response = getMagicCodeFromPath();
    // console.log("Magic Code from path:", response);
    setMagicCode(response);
    localStorage.setItem("magicCode", response);
  }, []);
  function Button({
    className,
    variant = "default",
    size = "default",
    asChild = false,
    ...props
  }) {
    const Comp = asChild ? "span" : "button";

    const baseStyles =
      "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 outline-none focus-visible:border-blue-500 focus-visible:ring-2 focus-visible:ring-blue-500/50";

    const variantStyles = {
      default: "bg-blue-500 text-white hover:bg-blue-600",
      destructive: "bg-red-500 text-white hover:bg-red-600",
      outline: "border border-gray-300 bg-white text-gray-700 hover:bg-gray-50",
      secondary: "bg-gray-200 text-gray-900 hover:bg-gray-300",
      ghost: "hover:bg-gray-100 hover:text-gray-900",
      link: "text-blue-500 underline-offset-4 hover:underline",
    };

    const sizeStyles = {
      default: "h-9 px-4 py-2",
      sm: "h-8 rounded-md px-3 text-xs",
      lg: "h-10 rounded-md px-6",
      icon: "w-9 h-9 rounded-md",
    };

    const buttonClass = `${baseStyles} ${variantStyles[variant]} ${
      sizeStyles[size]
    } ${className || ""}`;

    return <Comp className={buttonClass} {...props} />;
  }
  const mockAgents = [
    {
      id: "1",
      name: "Charlotte",
      title: "Executive Secretary",
      description: "Secretary",
      activeAgentType: "secretary",
      image: agent1,
      imageSitting: "/Charlotte-sitting.png",
    },
    {
      id: "2",
      name: "Ethan",
      description: "Accountant",
      activeAgentType: "accountant",

      title: "Chief Technology Officer",
      image: agent2,
      imageSitting: "/Ethan-setting.png",
    },
    {
      id: "4",
      name: "Alex",
      description: "Trainer",
      activeAgentType: "trainer",

      title: "Executive Secretary",
      image: agent4,
      imageSitting: "/Maxwell-sitting.png",
    },
    {
      id: "7",
      name: "Sterling",
      description: "Assistant",
      activeAgentType: "legal_assistant",

      title: "Chief Technology Officer",
      image: agent6,
      imageSitting: "/sterling-sitting.png",
    },
    {
      id: "3",
      name: "Elena",
      description: "Accountant",

      title: "Chief Financial Officer",
      image: agent3,
      imageSitting: "/Elena-sitting.png",
    },

    {
      id: "5",
      name: "Sloane",
      description: "Accountant",

      title: "Executive Secretary",
      image: agent5,
      imageSitting: "/Salone-sitting.png",
    },
    // {
    //   id: "6",
    //   name: "Charlotte",
    //   description: "Secretary",
    //   activeAgentType: "secretary",

    //   title: "Executive Secretary",
    //   image: agent1,
    //   imageSitting: "/Charlotte-sitting.png",
    // },
  ];
  const handleSelectAgent = (agent) => {
    if (
      selectedAgents.length < 5 &&
      !selectedAgents.find((a) => a.id === agent.id)
    ) {
      setSelectedAgents([...selectedAgents, agent]);
    }
  };

  const handleRemoveAgent = (agentId) => {
    setSelectedAgents(selectedAgents.filter((agent) => agent.id !== agentId));
  };

  const isAgentSelected = (agentId) => {
    return selectedAgents.some((agent) => agent.id === agentId);
  };

  const canCreateBoardroom = selectedAgents.length >= 2;
  const isSelectionFull = selectedAgents.length >= 5;

  const handleCreateBoardroom = () => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
      // Navigate to the Boardroom page and pass selectedAgents via state
      localStorage.setItem("selectedAgents", JSON.stringify(selectedAgents));

      navigate("/boardroom");
    }, 1500);
  };

  return (
    <>
      <LoadingOverlay isVisible={isLoading} />
      <div className="app-container">
        <div className="main-card">
          <div className="header-section">
            <div className="header-left">
              <div className="logo-container">
                <img src={logoImage} alt="TIDE 360" className="logo" />
              </div>
              <h1 className="main-title">
                Choose <span className="blue-text">AI Agents</span>
                <br />
                to join your boardroom meeting
              </h1>
            </div>
          </div>

          <div className="agents-section">
            <div className="agents-scroll-container">
              <div className="agents-list">
                {mockAgents.map((agent) => (
                  <AgentCard
                    key={agent.id}
                    agent={agent}
                    onSelect={handleSelectAgent}
                    isSelected={isAgentSelected(agent.id)}
                    isDisabled={isSelectionFull && !isAgentSelected(agent.id)}
                  />
                ))}
              </div>
            </div>
          </div>

          <div className="bottom-section">
            <div className="selected-agents">
              {selectedAgents.map((agent) => (
                <SelectedAgent
                  key={agent.id}
                  agent={agent}
                  onRemove={handleRemoveAgent}
                />
              ))}
              {selectedAgents.length === 0 && (
                <p className="placeholder-text">
                  Select 2-5 agents to continue
                </p>
              )}
            </div>

            <Button
              size="lg"
              disabled={!canCreateBoardroom || !userDetails || isLoading}
              onClick={handleCreateBoardroom}
              className="create-button"
            >
              {isLoading ? "Creating..." : "Create Boardroom"}
              <Sparkle className="button-icon" />
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default SelectionPage;
